import React, { useState } from "react";
import { Jumbotron } from "react-bootstrap";
import { Alert } from "reactstrap";
import "./index.css";

import Flyer1 from "./Flyer1.png";
import Flyer2 from "./Flyer2.png";

const Home = () => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  return (
    <div>
      <Alert
        isOpen={visible}
        toggle={onDismiss}
        style={{
          margin: 0,
          backgroundColor: "#03fcc6",
          color: "#212529",
          borderRadius: 0,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1>
            <b>
              OUR CLASSES ARE STARTING! Sign
              up{" "}
              <a
                className="link"
                rel="noopener noreferrer"
                target="_blank"
                href="https://forms.gle/SmfRoMDZFdMUaxq88"
              >
                here
              </a>
              .
            </b>
          </h1>
        </div>
      </Alert>
      <Jumbotron
        style={{ margin: 0, backgroundColor: "#f58c0c", borderRadius: 0 }}
      >
        <h1>Envato</h1>
        <p>
          Welcome to our site. Envato is a small organization devoted to
          educating the young of our society to raise money for India and other
          countries' COVID-relief efforts.
        </p>
        <div className="flyer" style={{ textAlign: "center" }}>
          <img
            alt="Flyer Page 1"
            src={Flyer1}
            width="20%"
            className="flyerPage"
            style={{ marginRight: "10px" }}
          />
          <img
            alt="Flyer Page 2"
            src={Flyer2}
            width="20%"
            className="flyerPage"
            style={{ marginLeft: "10px" }}
          />
          <br></br>
          <a
            className="link"
            rel="noopener noreferrer"
            target="_blank"
            href="https://drive.google.com/file/d/1b7wBUZzT0q3KSkzbVTO4gCTcRY9ldMHs/view?usp=sharing"
          >
            Envato Houston 2021 Flyer
          </a>
        </div>
      </Jumbotron>
      {/* <Jumbotron style={{ margin: 0, borderRadius: 0 }}>
        <h1>Frequently Asked Questions</h1>
        <h3></h3>
      </Jumbotron> */}
    </div>
  );
}

export default Home;